import { api, endpoints } from "api/api";
import { BaseApiPaging } from "api/types";
import { AxiosPromise } from "axios";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
  orderBy: string
): AxiosPromise<BaseApiPaging<TopicApi>> => {
  return api.get<BaseApiPaging<TopicApi>>(endpoints.TOPICS.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (topicId: number): AxiosPromise<TopicApi> => {
  return api.get<TopicApi>(endpoints.TOPICS.GET_BY_ID(topicId));
};
const featchAppearances = (topicId: number): AxiosPromise<TopicAppearanceApi> => {
  return api.get<TopicAppearanceApi>(endpoints.TOPICS.GET_APPEARANCES(topicId));
};
const create = (data: CreateTopicRequest): AxiosPromise<TopicApi> => {
  return api.post<TopicApi>(endpoints.TOPICS.CREATE(), data);
};

const update = (topicId: number, data: CreateTopicRequest): AxiosPromise<TopicApi> => {
  return api.put<TopicApi>(endpoints.TOPICS.UPDATE(topicId), data);
};

const deleteTopic = (topicId: number): Promise<void> => {
  return api.delete(endpoints.TOPICS.DELETE(topicId));
};

export const topicsApi = {
  fetch,
  featchAppearances,
  fetchById,
  create,
  update,
  delete: deleteTopic,
};

type CreateTopicRequest = {
  title: string;
  description?: string;
  time: number;
  type: number;
  groupIds?: (string | undefined)[]; // Topicgroups
  courseGroupIds?: (string | undefined)[];
  trainersIds?: (string | undefined)[];
};

export interface TopicCourseGroupApi {
  courseGroupId: number;
  name: string;
}
export interface TopicApi {
  description: string;
  id: number;
  time: number;
  title: string;
  trainers: TopicTrainierApi[];
  type: number;
  courseGroups: TopicCourseGroupApi[];
  topicGroups: {
    id: number;
    name: string;
    time: number;
  }[];
}
export interface TopicAppearanceApi {
  course: {
    courseId: number;
    courseName: string;
    groupId?: number;
    groupName?: string;
  }[];
}
export interface TopicTrainierApi {
  id: number;
  topicId: number;
  trainerId: number;
  firstName: string;
  surname: string;
  prices: {
    name: string;
    type: number;
    amount: number;
  }[];
}
